import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {navigator} from 'lit-element-router';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {msg} from '@lit/localize';
import {when} from 'lit/directives/when.js';
import {choose} from 'lit/directives/choose.js';
import {repeat} from 'lit/directives/repeat.js';
import {generateKey} from '../../util/generateKey';

import store from '../../store';
import download from '../../../icons/download';
import view from '../../../icons/view';
import copy from '../../../icons/copy';
import checkmark from '../../../icons/checkmark';
import share from '../../../icons/share';
import reset from '../../../icons/reset';
import seluxLogo from '../../../icons/selux-logo';


import {
	selectSpcIsSatisfied,
	selectLdt1,
	selectLdt2,
	selectSpcSession,
	selectSpcConfiguration,
	selectBasicSpcAttributes,
	selectDetailSpcAttributes,
	selectBasicSpcAttributesSatisfied, selectFamily, selectSectionConfig, selectIsSingle, selectImages, selectProductImagesUrl, selectMountingInstruction,
	selectIsSatisfied, selectRelux, selectVariantCodeTypes, selectProductCodes
} from '../../selectors';
import {routeUrl} from '../../util/routeUrl';
import {setKey, setOriginalKey} from '../../slices/statusSlice';
import {storeConfiguration, unFinalize} from '../../slices/configurationSlice';


@customElement('visual-finalize')
export class VisualFinalize extends connect(store)(navigator(LitElement)) {

	static styles = css`
		:host {
			width: 100%;
			display: flex;
			flex-direction: column;
		}

		.finalize {
			display: flex;
			flex-direction: column;
			gap: 20px;
			width: 100%;
			height: 100vh;
			margin: 0;
			padding: 0;
			max-height: initial;
			box-sizing: border-box;
			overflow-y: scroll;
		}

		.logo {
			position: absolute;
			top: var(--large-padding);
			left: var(--large-padding);
		}

		.logo-link {
			display: block;
			width: 70px;
		}

		.header {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			gap: var(--large-padding);
			color: var(--color-white);
			padding: var(--large-padding) 0 0 0;
		}

		.date {
			font: var(--font-section-title);
		}

		.title {
			text-align: center;
			font: var(--font-modal-title-regular);
			color: var(--color-white);
			padding-bottom: 40px;
		}

		.titleSubheading {
			text-align: center;
			font: var(--font-modal-title);
			margin: 0;
		}

		.content {
			display: flex;
			flex-direction: column;
			margin: 0 auto;
			max-width: 940px;
			padding: 0 var(--large-padding) 0 var(--very-large-padding);
		}

		.specsheet {
			border-bottom: 1px solid var(--color-grey5);
			padding-bottom: var(--very-large-padding);
			margin-bottom: var(--very-large-padding);
			gap: var(--large-padding);
		}

		.nextSteps {
			border-bottom: 1px solid var(--color-grey5);
			padding-bottom: var(--very-large-padding);
			margin-bottom: var(--very-large-padding);
		}

		.sectionHeading {
			font: var(--font-section-title-regular);
			color: var(--color-white);
			margin-bottom: var(--large-padding);
		}

		.sectionSubHeading {
			font: var(--font-section-title);
			color: var(--color-white);
			margin-bottom: var(--large-padding);
		}

		.sectionLabel {
			font: var(--font-section-label);
			color: var(--color-white);
			margin-bottom: var(--padding);
		}

		.specId-button {
			display: flex;
			font: var(--font-widget-big-label);
			color: var(--color-black);
			background-color: var(--color-cta-button);
			width: 100%;
		}

		.specId-description {
			font: var(--font-widget-label);
			color: var(--color-grey4);
		}

		.section {
			border-bottom: 1px solid var(--color-grey5);
			padding: 30px 0;
			display: flex;
			flex-direction: row;
			gap: 30px;
		}

		.nextSteps-block {
			display: flex;
			flex-direction: column;
			padding-bottom: var(--very-large-padding)
		}

		.nextSteps-group {
			display: flex;
			flex-direction: column;
			gap: var(--very-small-padding);
			padding-bottom: var(--very-small-padding)
		}

		button {
			padding: var(--very-small-padding) var(--padding);
			text-align: left;
			font: var(--font-widget-label);
			color: var(--color-black);
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			gap: var(--very-small-padding) var(--padding);
			background-color: transparent;
			border: none;
			cursor: pointer;
		}

		.finalizeInfo {
			font: var(--font-section-title);
			color: var(--color-black);
		}

		.configurationId {
			font: var(--font-widget-small-title);
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			border: 1px solid var(--color-grey2);
			padding: var(--very-small-padding) var(--padding);
			color: var(--color-grey1);
		}

		.downloadButton {
			width: 100%;
			font: var(--font-widget-label);
			color: var(--color-white);
			background-color: var(--color-grey6);
		}

		.actionButton {
			width: 100%;
			font: var(--font-widget-label);
			color: var(--color-white);
			background-color: var(--color-grey6);
		}

		.specsheet {
			display: flex;
			flex-direction: row;
			gap: var(--very-large-padding);
			padding-top: var(--very-large-padding);
		}

		.specsheetContent {
			display: flex;
			flex-direction: column;
			flex-basis: 100%;
			gap: var(--large-padding);
		}

		.specsheetImage {
			max-width: 300px;
			display: flex;
			flex-direction: column;
			align-items: start;
			justify-content: start;
			flex-basis: 300px;
			background-color: var(--color-grey7);
		}

		.specsheetImage > * {
			margin: auto;
			max-height: 650px;
		}


		.specsheetDownloads {
			display: flex;
			flex-direction: column;
			gap: var(--very-small-padding);
		}

		.specsheetDownload {
			width: 100%;
			font: var(--font-widget-label);
		}

		.downloadItem {
			width: 100%;
			font: var(--font-widget-small-title);
			color: var(--color-white);
			background-color: var(--color-black);
			border-bottom: 1px solid var(--color-grey6);
			padding: var(--small-padding) 0;
		}

		.downloadItem:first-child {
			border-top: 1px solid var(--color-grey6);
		}

		.newConfiguration {
			font: var(--font-widget-small-title);
			color: var(--color-white);
			background-color: var(--color-grey6);
		}

		.copyConfiguration {
			font: var(--font-widget-small-title);
			color: var(--color-white);
			background-color: var(--color-grey6);
		}

		.icon {
			display: inline-block;
			height: 16px;
			width: 16px;
			margin-right: 10px;
		}
		.icon.copy {
			color: var(--color-grey4);
		}

		.price {
			font-family: var(--font-family-light);
		}

	`;

	constructor() {
		super();
		this.closeTimout = null;
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.lang = state.status.lang;
		this.finalized = state.configuration.data.finalized;
		this.loading = state.configuration.status === 'loading';
		this.sectionConfig = selectSectionConfig(state);
		this.shortNumberProductModel = state.shortNumber.data.ProductModel ?? '';
		this.shortKey = this.status.shortKey;
		this.dataKey = state.status.dataKey;
		//this.dataKey = state.configuration.data.dataKey;
		this.url = this.status.baseUrl + this.status.region + '/' + this.status.lang + '/' + this.status.family + '/' + this.status.mode + '/' + this.dataKey;

		this.relux = selectRelux(state);
		this.spcIsSatisfied = selectSpcIsSatisfied(state);
		this.session = selectSpcSession(state);
		this.spcConfiguration = selectSpcConfiguration(state);
		this.basicSpcAttributes = selectBasicSpcAttributes(state);
		this.isBasicSatisfied = selectBasicSpcAttributesSatisfied(state);
		this.detailSpcAttributes = selectDetailSpcAttributes(state);
		this.ldt1 = selectLdt1(state);
		this.ldt2 = selectLdt2(state);
		this.family = state.status.family;
		this.olivioImages = selectImages(state);
		this.created = new Date(state.configuration.data.created);
		this.dateString = this.created.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
		this.region = state.status.region;
		this.price = state.price.data;
		this.isSatisfied = selectIsSatisfied(state);
		this.copiedToClipboard = false;
	}

	connectedCallback() {
		super.connectedCallback();
	}

	copySpecId() {
		window.navigator.clipboard.writeText(this.shortKey);
	}

	reluxUrl(type) {
		const configurationPath = this.status.baseUrl + 'config/' + this.status.family + '/' + this.dataKey + '/';
		const file = this.relux?.find(r => r.type === type);
		if (file === undefined) {
			return undefined;
		} else {
			const filename = file.url.split('/').pop();
			return configurationPath + filename;
		}
	}

	downloadSpecsheet() {
		let configurationPath = this.status.baseUrl + 'config/' + this.status.family + '/' + this.dataKey + '/';
		if (this.status.family === 'TheLine') {
			configurationPath = 'https://www.selux.com/configuration2/config/Line/' + this.dataKey + '/';
		}
		const url = configurationPath + 'specsheet.pdf';
		console.log('downloadSpecsheet', url);
		window.open(url, '_blank');
	}

	downloadTendertext() {
		let configurationPath = this.status.baseUrl + 'config/' + this.status.family + '/' + this.dataKey + '/';
		if (this.status.family === 'TheLine') {
			configurationPath = 'https://www.selux.com/configuration2/config/Line/' + this.dataKey + '/';
		}
		const url = configurationPath + 'tendertext.txt';
		window.open(url, '_blank');
	}
	async copyTendertextToClipboard() {
		let configurationPath = this.status.baseUrl + 'config/' + this.status.family + '/' + this.dataKey + '/';
		if (this.status.family === 'TheLine') {
			configurationPath = 'https://www.selux.com/configuration2/config/Line/' + this.dataKey + '/';
		}
		const url = configurationPath + 'tendertext.txt';
		try {
			const response = await fetch(url);
			if (!response.ok) {
				throw new Error(`HTTP ${response.status}`);
			}
			const text = await response.text();
			await window.navigator.clipboard.writeText(text);
			this.copiedToClipboard = true;
			console.log('copied to clipboard', this.copiedToClipboard);
		} catch (err) {
			console.error('Failed:', err);
		}
		this.requestUpdate();
	}

	downloadArchive() {
		let configurationPath = this.status.baseUrl + 'config/' + this.status.family + '/' + this.dataKey + '/';
		if (this.status.family === 'TheLine') {
			configurationPath = 'https://www.selux.com/configuration2/config/Line/' + this.dataKey + '/';
		}
		const url = configurationPath + 'selux_' + this.status.family + '_' + this.shortKey + '.zip';
		window.open(url, '_blank');
	}

	downloadFile(url) {
		window.open(url, '_blank');
	}

	viewSpecsheet() {
		console.log('view Specsheet');
	}

	shareConfiguration() {
		// open share sheet of os
		window.navigator.share({
			title: 'Selux Configuration',
			url: window.location.href,
		});
	}

	async duplicateConfiguration(e) {
		const currentKey = this.state.configuration.data.dataKey;
		const newKey = generateKey();
		await store.dispatch(setOriginalKey({key: currentKey}));
		await store.dispatch(setKey({key: newKey}));
		await store.dispatch(unFinalize());
		await store.dispatch(storeConfiguration());
		this.navigate(routeUrl({media: 'sections', key: newKey}));
		window.location.reload();
	}

	startNewConfiguration(e) {
		console.log('start new configuration');
		this.navigate(routeUrl({media: 'sections', key: 'new'}));
		window.location.reload();
	}

	download(url) {
		window.open(url);
	}
	isPriceVisible() {
		return this.region === 'ger' && this.isSatisfied && this.state.status.family === 'Line';
	}
	render() {
		const state = this.state;
		const familyString = selectFamily(this.state);
		return html`
			<div class="finalize">
				<div class="logo">
					<a href="https://selux.com" target="_blank" class="logo-link">
						${seluxLogo}
					</a>
				</div>
				<header class="header">
					<div class="date">${this.dateString}</div>
					<div class="title">
						<div class="titleHeading">${familyString} ${msg('Configuration')}</div>
						<!-- <p class="titleSubheading">Mastleuchte mit 2 Leuchtenköpfen</p> -->
					</div>
				</header>

				<div class="content">

					<!-- Spezifikations-ID ─────────── -->
					<section class="specId">
						<div class="sectionLabel">${msg('Specification ID')}</div>

						<button class="specId-button" @click="${() => this.copySpecId()}">
							<span class="specId-value">${this.shortKey}</span>
							<span class="icon">${copy}</span>
						</button>

						<p class="specId-description">
							Die Spezifikations-ID dient der eindeutigen Identifizierung Ihrer Auswahl und wird einmalig vergeben.
							Bitte bewahren Sie diese auf, wenn zu einem späteren Zeitpunkt auf die Konfiguration zugegriffen werden soll.
						</p>
					</section>

						<!-- Produkte und Bauteile ────────
					<section class="parts">
						<div class="partsHeader">
							<span class="partsColumn">${msg('Products and Parts')}</span>
							<span class="partsColumn">${msg('Amount')}</span>
							<span class="partsColumn">${msg('Product ID')}</span>
							<span class="partsColumn"></span>
						</div>
						<ul class="partsList">
						</ul>
					</section>
					-->


					<!-- ─── SECTION: Datenblatt + Product Image ── -->
					<section class="specsheet">
						<div class="specsheetContent">

							${when(this.isPriceVisible(), () => html`
							<div class="specsheetBlock">
								<div class="sectionLabel">${msg('Price')}</div>

								<div class="price">${this.price.totalPriceInEuro} €</div>
							</div>
							`)}

							<div class="specsheetBlock">
								<div class="sectionLabel">${msg('Specsheet')}</div>

								<div class="specsheetDownloads">
									<button class="downloadButton specsheetDownload" @click="${() => this.downloadSpecsheet()}">
										<span class="label">
											<span>${msg('Download Specsheet')}</span>
											<span>PDF</span>
										</span>
										<span class="icon">${download}</span>
									</button>
									<!--
									<button class="downloadButton specsheetDownload" @click=${() => this.viewSpecsheet()}>
										<span class="label">${msg('View Specsheet')}</span>
										<span class="icon">${view}</span>
									</button>
									-->
								</div>
							</div>

							<div class="specsheetBlock">
								<div class="sectionLabel">Planungsdaten</div>

								<div class="downladItems">
									<button class="downloadItem" @click="${() => this.downloadTendertext()}">
										<span class="label">${msg('Download Tender Text')}</span>
										<span class="icon">${download}</span>
									</button>
									<button class="downloadItem" @click="${() => this.copyTendertextToClipboard()}">
										<span class="label">${msg('Copy Tender Text')}</span>
										<span class="icon copy">${this.copiedToClipboard ? checkmark : copy}</span>
									</button>

									${when(selectProductImagesUrl(this.state), () => html`
										<button class="downloadItem"
												@click=${() => this.download(selectProductImagesUrl(this.state) + '/product/' + familyString.toLowerCase())}>
											<span class="label">${msg('Product Images')}</span>
											<span class="icon">${download}</span>
										</button>
										<button class="downloadItem"
												@click=${() => this.download(selectProductImagesUrl(this.state) + '/project/' + familyString.toLowerCase())}>
											<span class="label">${msg('Project Images')}</span>
											<span class="icon">${download}</span>
										</button>
									`)}
									${when(selectMountingInstruction(this.state) !== null, () => html`
										<button class="downloadItem"
												?disabled=${selectMountingInstruction(this.state) !== null && selectMountingInstruction(this.state) === ''}
												@click=${() => this.download(selectMountingInstruction(this.state))}>
											<span class="label">${msg('Mounting instructions')}</span>
											<span class="icon">${download}</span>
										</button>
									`)}

									${when(this.ldt1 !== null, () => html`
										<button class="downloadItem"
										        @click=${() => this.downloadFile(this.ldt1)}>
											<span class="label">LDT</span>
											<span class="icon">${download}</span>
										</button>
									`)}
									${when(this.ldt2 !== null, () => html`
										<button class="downloadItem"
										        @click=${() => this.downloadFile(this.ldt2)}>
											<span class="label">LDT 2</span>
											<span class="icon">${download}</span>
										</button>
									`)}
									${when(this.reluxUrl('dwg') !== undefined, () => html`
										<button class="downloadItem" ?disabled=${this.reluxUrl('dwg') === undefined}
												@click=${() => this.downloadFile(this.reluxUrl('dwg'))}>
											<span class="label">DWG</span>
											<span class="icon">${download}</span>
										</button>
									`)}
									${when(this.reluxUrl('ies') !== undefined, () => html`
										<button class="downloadItem" ?disabled=${this.reluxUrl('ies') === undefined}
												@click=${() => this.downloadFile(this.reluxUrl('ies'))}>
											<span class="label">IES</span>
											<span class="icon">${download}</span>
										</button>
									`)}
									${when(this.reluxUrl('rfa') !== undefined, () => html`
										<button class="downloadItem" ?disabled=${this.reluxUrl('rfa') === undefined}
												@click=${() => this.downloadFile(this.reluxUrl('rfa'))}>
											<span class="label">RFA</span>
											<span class="icon">${download}</span>
										</button>`)}
									${when(this.reluxUrl('rolfz') !== undefined, () => html`
										<button class="downloadItem" ?disabled=${this.reluxUrl('rolfz') === undefined}
												@click=${() => this.downloadFile(this.reluxUrl('rolfz'))}>
											<span class="label">ROLFZ</span>
											<span class="icon">${download}</span>
										</button>
									`)}
									<button class="downloadItem" @click="${() => this.downloadArchive()}">
										<span class="label">Alle Dateien (ZIP)</span>
										<span class="icon">${download}</span>
									</button>

								</div>

							</div>

						</div>

						<!-- Product image placeholder -->
						<div class="specsheetImage">
							${choose(this.family, [
									[
										'Line',
										() => html`
											${when(selectIsSingle(state),
												() => html`
													<svg-optics-specsheet></svg-optics-specsheet>`,
												() => html`
													<svg-productimage></svg-productimage>`
											)}
										`
									],
									[
										'Olivio',
										() => html`
											${when(this.olivioImages, () => html`
												<img alt="side view" src="${this.olivioImages.side}" class="sideView"/>
											`)}
										`
									]
								]
							)}
						</div>
					</section>

					<!-- ─── SECTION: 2. Nächste Schritte ────────── -->
					<section class="nextSteps">
						<div class="sectionHeading">2. Nächste Schritte</div>

						<div class="nextSteps-block">
							<div class="sectionSubHeading">Wer soll von Ihrer Projektidee erfahren?</div>
							<div class="sectionLabel">Konfiguration teilen</div>
							<div class="nextSteps-group">
								<button class="actionButton" type="button" @click=${() => this.shareConfiguration()}>
									<span class="label">${msg('Share Configuration')}</span>
									<span class="icon">${share}</span>
								</button>
							</div>
						</div>

						<div class="nextSteps-block">
							<div class="sectionSubHeading">${msg('Start a new configuration')}</div>
							<div class="sectionLabel">${msg('More configurations')}</div>
							<div class="nextSteps-group">
								<button class="actionButton" type="button" @click=${() => this.startNewConfiguration()}>
									<span class="label">${msg('Start new configuration')}</span>
									<span class="icon">${reset}</span>
								</button>
								<button class="actionButton" type="button" @click=${() => this.duplicateConfiguration()}>
									<span class="label">${msg('Copy this configuration')}</span>
									<span class="icon">${share}</span>
								</button>
							</div>
						</div>
					</section>

					<!-- ─── SECTION: 3. Angebot anfragen ───────────
					<section class="quote">
						<div class="sectionHeading">3. Angebot anfragen</div>

						<p class="quoteDescription">
							Unsere Vertriebsmitarbeitenden freuen sich Ihnen bei der Umsetzung Ihrer Projektidee zu helfen.
						</p>

						<div class="contact-form">
							<span class="contact-form__label">Vertrieb kontaktieren</span>

							<div class="contact-form__fields">
								<input
									class="contact-form__input contact-form__input--name"
									type="text"
									placeholder="Ihr Name"
									autocomplete="name"
								/>
								<input
									class="contact-form__input contact-form__input--email"
									type="email"
									placeholder="Ihre Emailadresse"
									autocomplete="email"
								/>
								<button class="contact-form__submit" type="button">Senden</button>
							</div>

							<p class="contact-form__consent">
								Mit der Angabe Ihrer Emailadresse bestätigen Sie ihr Einverständnis zur Weiterverarbeitung Ihrer Daten.
							</p>
						</div>
					</section>
					-->

				</div>

			</div>

		`;
	}
}
